<div
  style="
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
  "
>
  <div style="display: flex; flex-direction: column; align-items: center">
    <h1>Bienvenue sur</h1>
    <img src="../../../assets/img/logo.png" alt="" />

    <p>
      Veuillez entrer le code d’identification fourni afin d’accéder à votre
      modèle.
    </p>

    <form [formGroup]="form" style="width: 100%">
      <mat-grid-list cols="4" rowHeight="3:2" gutterSize="1rem">
        <mat-grid-tile colspan="3">
          <mat-form-field style="width: 100%" subscriptSizing="dynamic">
            <mat-label>Code d'identification du modèle</mat-label>
            <input matInput formControlName="modelId" />
            <mat-error>Le code fourni est erroné. Veuillez réessayer</mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
          <button
            mat-button
            [disabled]="!form.valid"
            (click)="onClickOpenModel()"
          >
            Voir mon modèle
          </button>
        </mat-grid-tile>
      </mat-grid-list>
      @if (loadingSpinnerActive) {
      <div style="width: 100; display: flex; justify-content: center">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
      }
    </form>

    <!-- <p>
      Si vous souhaitez tester, vous pouvez
      <a href="">accédez gratuitement à l'espace démo.</a>
    </p> -->

    <p>
      Si vous souhaitez créer un modèle sur HIMP, contactez-nous par mail
      (info&#64;rweality.com)
    </p>
  </div>
</div>
